import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class BoxTitle extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        children: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { url, title },
        } = this.props;

        const props = url ? { href: url } : {};

        return (
            <a {...props} target="_blank" className={styles.box_title} title={title}>
                <span className={styles.bar} />
                <span className={styles.title}>{title}</span>
                {this.props.children}
            </a>
        );
    }
}

export default errorBoundary(BoxTitle);
